import classNames from 'classnames';
import { useMemo } from 'react';

type Props = {
    total: number;
    current: number;
    className?: string;
};
export function ProgressBar({ current, total, className }: Props) {
    const percent = useMemo(
        () => Math.round(((current - 1) / total) * 100),
        [current, total],
    );

    return (
        <div
            className={classNames(
                className,
                'my-20 h-5 w-full rounded bg-darker-grey',
            )}
        >
            <div
                className="h-5 min-w-5 max-w-full rounded bg-vibrant-blue"
                style={{ width: `${percent}%` }}
            />
        </div>
    );
}
